import * as types from './types';
import {RTMSConnectionState, RTMSMessage} from '../types';

export function setConnectedState(connectionState: RTMSConnectionState) {
    return {type: types.RTMS_CONNECTED_STATE_SET, connectionState}
}

export function MessageReceived(message: RTMSMessage) {
    return {type: types.RTMS_MESSAGE_RECEIVED, message}
}